import type {
  EliteInsightsCta,
  EliteOnboardingStatusResponse,
  EliteSubscriptionPlanDetails,
  EliteSubscriptionUpgradePricingDetails
} from '../../types/misc.types'
import { updateCtaWithSelectedPlanId } from '../new-elite-landing/components/NewEliteLandingPlanSelector'

export type ElitePrimeUpgradeDetails = {
  upgradeCta: EliteInsightsCta
  upgradePlanDetails?: EliteSubscriptionPlanDetails
  upgradePricingDetails?: EliteSubscriptionUpgradePricingDetails
}

/** Elite → Elite Prime upgrade path when `upgradeCta` is present. */
export function resolveElitePrimeUpgradeDetails(
  status?: EliteOnboardingStatusResponse
): ElitePrimeUpgradeDetails | null {
  const upgradeCta = status?.subscriptionDetails?.upgradeDetails?.upgradeCta
  if (!upgradeCta) {
    return null
  }
  return {
    upgradeCta,
    upgradePlanDetails:
      status?.subscriptionDetails?.upgradeDetails?.upgradePlanDetails ??
      status?.subscriptionDetails?.upgradePlanDetails,
    upgradePricingDetails: status?.subscriptionDetails?.upgradeDetails?.upgradePricingDetails
  }
}

/** Posts upgrade CTA with `effectivePlanId` placeholder replaced, same as buy CTAs. */
export function buildElitePlansUpgradeCtaPayload(
  upgradeDetails: ElitePrimeUpgradeDetails
): Record<string, unknown> {
  const planId =
    upgradeDetails.upgradePlanDetails?.effectivePlanId ??
    upgradeDetails.upgradePlanDetails?.basePlanId ??
    ''
  if (!planId) {
    return { ...(upgradeDetails.upgradeCta ?? {}) }
  }
  return updateCtaWithSelectedPlanId(upgradeDetails.upgradeCta, planId)
}
